import React, { useState, useImperativeHandle, useContext, useEffect } from 'react';
import TContext from '../context'
import { Input, TextArea, Tabs, Range, Infiniteloading, Toast, ConfigProvider } from '@nutui/nutui-react';

var { AlphaPicker,SketchPicker  } = require('@hello-pangea/color-picker');

import loadFont from '../../../lib/font'
import http from '../../../lib/http'
import * as apis from '../../../lib/apis'
import { cloneDeep } from 'lodash';

const textColor = ["#FFFFFF", "#000000", "#4D4D4D", "#808080", "#B3B3B3", "#E6E6E6", "#3b2722", "#5a3f34", "#9f877d", "#d4cbc4", "#556c78", "#90a0ad", "#ced6da", "#f7e6b0", "#f7f4c3", "#f1f5e6", "#e3f0fb", "#eae6f3", "#f4dae2", "#fad3cb", "#205d62", "#3a9284", "#8cba53", "#4d6d45", "#b7d332", "#a5cea3", "#84c4ba", "#a3bbe1", "#9ca1d0", "#4b9ed8", "#1d5192", "#1e296e", "#3f4fa0", "#432082", "#584096", "#853b92", "#831e4c", "#e60012", "#e24c3d", "#f188ac", "#f69796", "#f38435", "#e4ad35", "#edd481", "#f6f19d", "#f0cb59", "#be8a2f", "#2c2929"]


interface Props {
    action?: any,
    onPaneKeyChange?: (paneKey: number) => void;
    preloadedData?: any;
    dataLoading?: boolean;
}

export interface Action {
    setShow?: (isShow: boolean) => void;
    editShow?: () => void; //编辑的显示
    setTitle?: (s: string) => void; //设置title文字
    confirm?: () => boolean;
    cancel?: () => void;
    getPaneKey?: () => number | undefined;
}

export const Height = 580

var previewTextObject: any = null
var tempJson: any = null

const Index = (props: Props) => {
    const [show, setInnerShow] = useState(false)
    const [currentColor, setCurrentColor] = useState<string>(textColor[1])
    const [fontWeight, setFontWeight] = useState<string>("normal")
    const [fontStyle, setFontStyle] = useState<string>("normal")
    const [fontFamily, setFontFamily] = useState<string>()
    const [title, setTitle] = useState<string>("文字设置")
    const [fontOpacity, setFontOpacity] = useState<number>()
    const [inputText, setInputText] = useState<string>("")
    const [swiperClient, setSwiperClient] = useState<any>()
    const [paneKey, setPaneKey] = useState<number>()
    const [page, setPage] = useState<number>()
    const [fontList, setFontList] = useState<any>({ list: [], count: 0 })
    const [isVisible, setIsVisible] = useState(false) // 添加可见状态
    const tc = useContext(TContext)

    const [hasInitialized, setHasInitialized] = useState(false);
    const {
        preloadedData,
        dataLoading = false
    } = props;

    useEffect(() => {
        // 如果有预加载的数据，直接使用

        if (preloadedData && !hasInitialized) {
            setFontList({
                list: preloadedData.list || [],
                count: preloadedData.count || 0
            });
            setPage(1);
            setHasInitialized(true);
        }
        // 如果没有预加载数据且不在加载中，执行原有的初始化
        else if (!preloadedData && !dataLoading && !hasInitialized) {
            setShow(true);
            // 这里可能需要调用你原有的初始化函数
            // initData();
        }
    }, [preloadedData, dataLoading, hasInitialized]);
    useImperativeHandle(props.action, (): Action => ({
        setShow,
        confirm,
        cancel,
        setTitle,
        editShow,
        getPaneKey: () => paneKey,
    }));
    //加载字体列表
    const loadList = async (pageNum: number) => {
        try {
            const list: any = await http.get(apis.DESIGNER_FONT, {
                params: {
                    page: pageNum,
                    limit: 45,
                }
            })

            if (pageNum === 1) {
                // 第一页，直接替换
                setFontList(list)
            } else {
                // 加载更多，合并数据
                setFontList((prev: any) => ({
                    ...list,
                    list: [...prev.list, ...list.list]  // 合并列表
                }))
            }
            return list
        } catch (error) {
            console.error('加载字体列表失败:', error)
        }
    }

    // 加载更多
    const onLoadMore = async (done: () => void) => {
        const currentPage = page || 1;
        const nextPage = currentPage + 1
        try {
            await loadList(nextPage)
            setPage(nextPage)
        } catch (error) {
            console.error('加载更多失败:', error)
            // 失败时回退页码
            setPage(prev => (prev || 1) - 1);
        }
        done()
    }

    const editShow = () => {
        previewTextObject = tc.curActivityObject
        if (previewTextObject.type !== "text") {
            return
        }

        tempJson = tc?.fabricClient?.getJsonData()
        setPaneKey(0)
        setInnerShow(true)
        //初始字体
        setFontFamily(previewTextObject.fontFamily)
        //初始文字
        setInputText(previewTextObject.text)
        //设置颜色
        setCurrentColor(previewTextObject.fill)
        let colorIndex = textColor.findIndex(v => v === previewTextObject.fill)
        if (colorIndex === -1) {
            colorIndex = 0
        }
        swiperClient?.slideTo(colorIndex)
        //设置默认weight
        setFontWeight(previewTextObject.fontWeight || "normal")
        //设置默认斜体
        setFontStyle(previewTextObject.fontStyle || "normal")
        //设置默认字体透明度
        setFontOpacity(previewTextObject.opacity || 1)
    }

    const setShow = async (isShow: boolean) => {
        setInnerShow(isShow)
        if (isShow) {
            setIsVisible(true)
            tempJson = tc?.fabricClient?.getJsonData()
            const defaultTxt = ""
            const defaultColor = textColor[1]
            setPaneKey(0)
            //初始空文字
            setInputText(defaultTxt)
            //显示之后就预先添加一个空文本对象
            previewTextObject = tc?.curCanvasClient?.addText(defaultTxt)

            tc.curCanvasClient?.discardActiveObject()
            tc.curCanvasClient?.getFabricCanvas().renderAll()
            //设置默认颜色
            setCurrentColor(defaultColor)
            swiperClient?.slideTo(textColor.findIndex(v => v === defaultColor))
            previewTextObject.set({ fill: defaultColor })
            //设置默认weight
            setFontWeight("normal")
            //设置默认斜体
            setFontStyle("normal")
            //设置默认字体透明度
            setFontOpacity(1)
               Toast.loading(t("加载字体"), {
                cover: true, // 是否展示透明遮罩层
                // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                closeOnClickOverlay: false, // 点击遮罩可关闭
                duration: 0
            })
            const list = await loadList(1)
            setPage(1)
            if (!list.list) {
                Toast.fail(t("缺少字体资源"))
                return
            }
            try {
                // await choiceFontFamily(list.list[0])
            } catch (error) {
                Toast.fail(t("字体加载失败"))
                return
            }
            Toast.hide()
            if (!hasInitialized && fontList.list.length === 0) {
                Toast.loading(t("加载字体"), {
                    cover: true,
                    closeOnClickOverlay: false,
                    duration: 0
                })
                await loadList(1)
                Toast.hide()
            }
        } else {
            setTimeout(() => setIsVisible(false), 350)
        }
    }


    //监听文字输入变化
    const inputOnchange = (val: any) => {

        setInputText(val)
        if (!previewTextObject) {
            previewTextObject = tc?.curCanvasClient?.addText(val)
            tc.curCanvasClient.getFabricCanvas().viewportCenterObject(previewTextObject)
        } else {
            previewTextObject.text = val
            tc.curCanvasClient.getFabricCanvas().viewportCenterObject(previewTextObject)
        }
        tc.curCanvasClient.getFabricCanvas().renderAll()
        tc?.markAsChanged?.();
    }

    //确认
    const confirm = () => {
        if (!previewTextObject) {
            return false
        }
        if (!previewTextObject.text.trim()) {
            return false
        }
        tempJson = null
        tc.curCanvasClient.getFabricCanvas().renderAll()

        previewTextObject = null
        setInputText("")  // 清空输入框
        setCurrentColor(textColor[1])  // 重置颜色
        setFontWeight("normal")  // 重置字体粗细
        setFontStyle("normal")  // 重置字体样式
        setFontOpacity(1)  // 重置透明度
        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
        return true
    }

    // //取消
    const cancel = () => {
        previewTextObject = null
        setInnerShow(false)
        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
    }
    //选择颜色
    const choiceColor = (color: string) => {
        setCurrentColor(color)
        if (previewTextObject) {
            previewTextObject.set({ fill: color })
			previewTextObject.set({ hex: color })
            tc.curCanvasClient.getFabricCanvas().renderAll()
        }
    }
    const inputOnBlur = (e: any) => {
        let val = e.target.value
        setInputText(val)
        if (!previewTextObject) return
        previewTextObject.text = val
        tc.curCanvasClient.getFabricCanvas().viewportCenterObject(previewTextObject)
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    //字体透明度变化
    const fontOpacityChange = (val: any) => {
		setFontOpacity(val?.hsv?.a)
		console.log(val)
		previewTextObject.set({ hsl: val?.hsl })
		previewTextObject.set({ rgb: val?.rgb })
		previewTextObject.set({ hex: val?.hex })
		previewTextObject.opacity = val?.hsv?.a
		tc.curCanvasClient.getFabricCanvas().renderAll()
		return
        setFontOpacity(val)
        previewTextObject.opacity = val
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    //tabs切换
    const tabOnChange = async ({ paneKey }: any) => {
        setPaneKey(paneKey)
        props.onPaneKeyChange?.(paneKey)
    }
    useEffect(() => {
        if (paneKey !== undefined) {
            props.onPaneKeyChange?.(paneKey)
        }
    }, [])
    //选择字体
    const choiceFontFamily = async (v: any) => {
        setFontFamily(`font${v.id}`)
        try {

            await loadFont(`font${v.id}`, v.path)
            Toast.hide()
        } catch (error) {
            console.log(error)
            Toast.fail(t("字体加载失败"))
        }
        previewTextObject.fontFamily = `font${v.id}`
        previewTextObject.set("font_family_url", v.path)
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }



    return (
        <div>
            <div style={{
                zIndex: 11,
                background: "#FFFFFF",
                paddingBottom: tc.safeHeigth,

            }}>
                <div>
                    <TextArea style={{ padding: 4, height: 50, border: '1px solid #E5E5E5',  lineHeight: "normal" }} defaultValue={inputText} onBlur={inputOnBlur} onChange={inputOnchange} placeholder={t('请输入文字')} />
                </div>
                <div>
                    <Tabs background="#FFFFFF" value={paneKey} autoHeight onChange={tabOnChange} tabStyle={{
                        cursor: 'pointer',
                        userSelect: 'none'
                    }} >
                        <Tabs.TabPane title={t('样式')} >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-evenly",
                                cursor: "pointer",
								
                            }}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "20px",
                                        width: "100%",
                                        height: "100%",
                                        padding: "4px 10px",

                                    }}
                                >
                                    {
                                        textColor?.map((v: any, k: number) => (
                                            <div
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    choiceColor(v)
                                                }}
                                                key={v}
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: "50%",
                                                    background: v,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: `1px solid ${textColor[textColor.length - k - 1]}`,
                                                    cursor: "pointer", // 添加指针样式
                                                    flexShrink: 0 // 防止元素缩小
                                                }}
                                            >

                                                <div style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    borderRadius: "50%",
                                                }}></div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: 24,
                            }}>
                                <span style={{
                                    fontSize: 12,
                                    flexShrink: 0,
                                    marginRight: 10
                                }}>{t('透明度')}</span>
								
								<div style={{
									width: "90%",
									position: "relative"
								}}>
								
									<AlphaPicker color={ previewTextObject?.hex } rgb={ previewTextObject?.rgb } hsl={ previewTextObject?.hsl } width={"90%"} onChangeComplete={ fontOpacityChange }/>
								</div>
                            </div>

                        </Tabs.TabPane>
                        <Tabs.TabPane title={t('字体')}>
                            <div id="fontScroll" style={{
                                height: "calc(100vh - 248px)",
                                overflowY: "auto",
                                overflowX: "hidden",
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none'
                            }}>
                                <Infiniteloading
                                    loadIcon=""
                                    containerId="fontScroll"
                                    useWindow={false}
                                    hasMore={preloadedData?.count !== preloadedData?.list?.length}
                                    onLoadMore={onLoadMore}
                                >
                                    <div style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "20px",
                                        padding: 0
                                    }}>
                                        {
                                            fontList?.list?.map((v: any) => (
                                                <div onClick={async () => {
                                                    Toast.loading(t("加载字体"), {
                                                        cover: true, // 是否展示透明遮罩层
                                                        // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                                                        closeOnClickOverlay: false, // 点击遮罩可关闭
                                                        duration: 0
                                                    })
                                                    await choiceFontFamily(v)
                                                    Toast.hide()
                                                }} style={{
                                                    width: `150px`,
                                                    height: `80px`,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: 6,
                                                    border: fontFamily === `font${v.id}` ? "1px solid #b0cd76" : "1px solid rgb(238, 238, 238)",
                                                    // background: v.cover ? `url("${v.cover + "?x-oss-process=image/resize,w_100"}")` : "#eee",
                                                    backgroundSize: "50% 50%",
                                                    backgroundPosition: "center center",
                                                    cursor: "pointer",
                                                }} key={v.id}>
                                                    {v.cover ? (
                                                        <img
                                                            src={v.cover}
                                                            alt={v.name}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover", // 保持图片的宽高比例，裁剪填满容器
                                                                borderRadius: 6
                                                            }}
                                                        />
                                                    ) : (
                                                        t(v.name)
                                                    )}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </Infiniteloading>
                            </div>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}

export default Index
